import React from 'react';
import SectionHeader from './ui/SectionHeader';

const STEPS = [
  {
    number: '01',
    title: 'Create your profile',
    description: 'Sign in securely. Add photos and details on your terms — stay discoverable without oversharing.',
    emoji: '👤',
  },
  {
    number: '02',
    title: 'Choose your vibe',
    description: 'Set how you want to show up — dating, chat, friends, or just browsing — and how long you’re visible.',
    emoji: '✨',
  },
  {
    number: '03',
    title: 'Connect safely',
    description: 'Explore nearby, poke, or message — with screenshot protection and verification when you want it.',
    emoji: '💬',
  },
  {
    number: '04',
    title: 'Stay in control',
    description: 'Block, report, or adjust visibility anytime. Your safety settings stay in your hands.',
    emoji: '🛡️',
  },
];

function HowItWorks() {
  return (
    <section id="how" className="relative overflow-hidden py-24 md:py-32">
      <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-primary/10 blur-[100px]" aria-hidden />

      <div className="site-container relative">
        <SectionHeader
          tag="Simple by design"
          title="How it"
          titleAccent="works"
          description="Four steps. Privacy at every one — whether you’re here to date, hook up, or connect."
        />

        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {STEPS.map((step, index) => (
            <article key={step.number} className="glass-card-hover relative p-6">
              {index < STEPS.length - 1 && <span className="step-connector" aria-hidden />}
              <span className="absolute right-4 top-4 text-4xl font-black text-white/[0.04]">{step.number}</span>
              <div className="feature-icon-box mb-5">{step.emoji}</div>
              <h3 className="mb-2 font-bold text-white">{step.title}</h3>
              <p className="text-sm leading-relaxed text-silver">{step.description}</p>
            </article>
          ))}
        </div>

        <div className="mt-12 rounded-3xl border border-primary/20 bg-gradient-to-r from-primary/10 to-transparent p-8 text-center md:p-10">
          <div className="mb-3 text-3xl">🔐</div>
          <h3 className="mb-2 text-xl font-bold text-white md:text-2xl">Privacy isn’t a setting here</h3>
          <p className="mx-auto max-w-2xl text-silver leading-relaxed">
            It’s the foundation — from sign-up to every chat and date.
          </p>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
